import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end gap-2" }
const _hoisted_2 = { class: "flex justify-end gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-surface-500 dark:text-surface-400 block mb-8" }, " Êtes-vous sûr de vouloir supprimer cette géolocalisation ? ", -1)
const _hoisted_4 = { class: "flex justify-end gap-2" }
const _hoisted_5 = { class: "flex justify-end gap-2" }
const _hoisted_6 = { class: "flex justify-between items-center mb-4" }
const _hoisted_7 = { class: "page-title" }
const _hoisted_8 = { class: "flex gap-2" }
const _hoisted_9 = { class: "flex justify-end w-full" }
const _hoisted_10 = { class: "flex justify-between items-center w-full" }
const _hoisted_11 = { class: "p-input-icon-left relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Chargement...", -1)
const _hoisted_16 = { class: "text-center py-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map-marker text-4xl text-gray-400 mb-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Aucune position trouvée", -1)
const _hoisted_19 = { class: "column-header-with-search geo-col w-full" }
const _hoisted_20 = { class: "column-search-input" }
const _hoisted_21 = { class: "column-header-with-search geo-col w-full" }
const _hoisted_22 = { class: "column-search-input" }
const _hoisted_23 = { class: "column-header-with-search geo-col w-full" }
const _hoisted_24 = { class: "column-search-input" }
const _hoisted_25 = { class: "block max-w-[200px]" }
const _hoisted_26 = { class: "column-header-with-search geo-col w-full" }
const _hoisted_27 = { class: "column-search-input" }
const _hoisted_28 = {
  key: 0,
  class: "flex gap-2"
}

import { ref, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { FilterMatchMode } from 'primevue/api';
import { deleteGeolocation, getOptionsCountry, getCountryCodeByName } from '@/_services/geolocation/country';
import { productService } from '@/_services/product/product';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import ProgressSpinner from 'primevue/progressspinner';
import FormGeolocation from "@/components/forms/product/FormGeolocationEdition.vue";
import { debounce } from 'lodash-es';
import axios from 'axios';
import { useGeolocationStore } from '@/stores/geoloc/geolocationStore';
import Tooltip from 'primevue/tooltip';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";

interface Geolocation {
    uuid: string;
    id: string;
    latitude: number;
    longitude: number;
    formattedAddress: string;
    address?: string;
    zipCode?: string;
    city?: string;
    country_code?: string;
}

interface GeolocationReference {
    uuid?: string;
    manualMethod: string;
    address: string | null;
    zipCode: string | null;
    city: string | null;
    country_code: string;
    latitude: string | number | null;
    longitude: string | number | null;
    formattedAddress: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GeolocationsPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const toast = useToast();
const loading = ref(false);
const deleteLoading = ref(false);
const addLoading = ref(false);
const editLoading = ref(false);
const deleteDialogVisible = ref(false);
const openAddPositionDialog = ref(false);
const editDialogVisible = ref(false);
const selectedGeolocationUuid = ref<string | null>(null);
const selectedGeolocation = ref<Geolocation | null>(null);
const geolocations = ref<Geolocation[]>([]);
const productName = ref<string>('');
const geolocationStore = useGeolocationStore();
const isApiFiltered = ref(false);

// Pagination variables
const rowsPerPage = ref(30);
const currentPage = ref(1);

// Search variables
const searchId = ref('');
const searchLatitude = ref('');
const searchLongitude = ref('');
const searchAddress = ref('');
const searchCountry = ref('');
const totalItems = ref(0);

// Variables pour suivre la recherche en cours (pour la pagination)
const currentSearchField = ref('');
const currentSearchValue = ref('');

const tableKey = ref(0);
const openImportFileDialog = ref(false);
const selectedImportCountry = ref('FR');

const geolocationReference = ref<GeolocationReference>({
    uuid: null,
    manualMethod: 'address',
    address: null,
    zipCode: null,
    city: null,
    country_code: 'FR',
    latitude: null,
    longitude: null,
    formattedAddress: null
});

const countryOptions = ref(getOptionsCountry());

const geolocationFilters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    latitude: { value: null, matchMode: FilterMatchMode.CONTAINS },
    longitude: { value: null, matchMode: FilterMatchMode.CONTAINS },
    formattedAddress: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const fetchProductData = async (   
    techUuid: string,
    page = 1,
    itemsPerPage = rowsPerPage.value
) => {
    loading.value = true;
    try {
        if (!techUuid || typeof techUuid !== 'string') {
            throw new Error('UUID technique non valide');
        }

        const params = {
            page: String(page),
            itemsPerPage: String(itemsPerPage)
        };

        const response = await productService.productLocations(techUuid, params);

        if (response) {
            if ('items' in response && Array.isArray(response.items)) {
                geolocations.value = response.items;
                totalItems.value = response.totalItems || 0;
                currentPage.value = page;
                rowsPerPage.value = itemsPerPage;

                if (response.items.length === 0 && totalItems.value > 0 && page > 1) {
                    return fetchProductData(techUuid, 1, itemsPerPage);
                }

                forceTableRefresh();
            } else {
                geolocations.value = [];
                totalItems.value = 0;
                toast.add({
                    severity: 'warn',
                    summary: 'Avertissement',
                    detail: 'Format de réponse API inattendu',
                    life: 5000,
                });
            }
        } else {
            geolocations.value = [];
            totalItems.value = 0;
            productName.value = 'Produit non trouvé';
        }
    } catch (error) {
        let errorMessage = 'Impossible de charger les données du produit';

        if (error.response) {
            if (error.response.status === 404) {
                errorMessage = 'Produit non trouvé ou pas de géolocalisations disponibles';
            } else if (error.response.status === 401 || error.response.status === 403) {
                errorMessage = 'Vous n\'avez pas les droits d\'accès nécessaires';
            }
        }

        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: errorMessage,
            life: 5000,
        });

        geolocations.value = [];
        totalItems.value = 0;
    } finally {
        loading.value = false;
    }
};

const forceTableRefresh = () => {
    tableKey.value++;
};

const onPageChange = (event: any) => {
    const newPage = event.page + 1;
    const itemsPerPage = event.rows;

    const rowsChanged = itemsPerPage !== rowsPerPage.value;

    const techUuid = getTechnicalUuid();

    rowsPerPage.value = itemsPerPage;

    if (rowsChanged) {
        currentPage.value = 1;
        forceTableRefresh();
    } else {
        currentPage.value = newPage;
    }

    if (isApiFiltered.value) {
        loading.value = true;

        let searchField = 'search';
        let searchValue = '';

        if (geolocationFilters.value.global.value) {
            searchField = 'search';
            searchValue = geolocationFilters.value.global.value;
        } else if (searchLatitude.value) {
            searchField = 'latitude';
            searchValue = searchLatitude.value;
        } else if (searchLongitude.value) {
            searchField = 'longitude';
            searchValue = searchLongitude.value;
        } else if (searchAddress.value) {
            searchField = 'formattedAddress';
            searchValue = searchAddress.value;
        }

        if (searchValue && searchValue.trim() !== '') {
            const paginationParams = {
                page: String(currentPage.value),
                perPage: String(itemsPerPage)
            };

            productService.searchGeolocations(
                techUuid,
                searchField,
                searchValue.trim(),
                paginationParams
            ).then(response => {
                let items = [];
                let total = 0;

                if (response) {
                    if (response['hydra:member'] && Array.isArray(response['hydra:member'])) {
                        items = response['hydra:member'];
                        total = response['hydra:totalItems'] || 0;
                    } else if (response.items && Array.isArray(response.items)) {
                        items = response.items;
                        total = response.totalItems || 0;
                    } else if (response.data && response.data['hydra:member'] && Array.isArray(response.data['hydra:member'])) {
                        items = response.data['hydra:member'];
                        total = response.data['hydra:totalItems'] || 0;
                    } else if (response.data && Array.isArray(response.data)) {
                        items = response.data;

                        if (response.totalItems !== undefined) {
                            total = response.totalItems;
                        } else if (response.data['hydra:totalItems'] !== undefined) {
                            total = response.data['hydra:totalItems'];
                        } else {
                            total = totalItems.value > 0 ? totalItems.value : items.length;
                        }
                    } else if (Array.isArray(response)) {
                        items = response;
                        total = totalItems.value > 0 ? totalItems.value : items.length;
                    }
                }

                if (items.length > 0) {
                    geolocations.value = items;
                    if (total > 0) {
                        totalItems.value = total;
                    }
                    forceTableRefresh();
                } else {
                    if (totalItems.value > 0 && currentPage.value > 1) {
                        currentPage.value = currentPage.value - 1;
                        onPageChange({ page: currentPage.value - 1, rows: itemsPerPage });
                    } else {
                        geolocations.value = [];
                        totalItems.value = 0;
                        forceTableRefresh();
                    }
                }
            }).catch(error => {
                toast.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Impossible de charger la page demandée',
                    life: 3000,
                });
            }).finally(() => {
                loading.value = false;
            });

            return;
        }
    }

    const pageToFetch = rowsChanged ? 1 : currentPage.value;
    fetchProductData(techUuid, pageToFetch, itemsPerPage).then(() => {
        forceTableRefresh();
    });
};

const resetForm = () => {
    geolocationStore.resetForm();
    selectedGeolocation.value = null;
};

const resetFormBeforeShow = () => {
    geolocationStore.resetForm();

    geolocationReference.value = {
        uuid: null,
        manualMethod: 'address',
        address: null,
        zipCode: null,
        city: null,
        country_code: 'FR',
        latitude: null,
        longitude: null,
        formattedAddress: null
    };
};

const openDeleteDialog = (uuid: string) => {
    selectedGeolocationUuid.value = uuid;
    deleteDialogVisible.value = true;
};

const closeAddDialog = () => {
    openAddPositionDialog.value = false;
    resetForm();
};

const closeImportFileDialog = () => {
    openImportFileDialog.value = false;
    selectedImportCountry.value = 'FR';
};

const openEditDialog = (geolocation: Geolocation) => {
    selectedGeolocation.value = geolocation;
    geolocationStore.setEditMode(true);

    let country_code = geolocation.country_code || 'FR';
    country_code = getCountryCodeByName(country_code);

    geolocationStore.initGeolocationForm({
        uuid: geolocation.uuid,
        manualMethod: 'address',
        address: geolocation.address || '',
        zipCode: geolocation.zipCode || '',
        city: geolocation.city || '',
        country_code: country_code,
        latitude: String(geolocation.latitude) || '',
        longitude: String(geolocation.longitude) || '',
        formattedAddress: geolocation.formattedAddress || ''
    });

    geolocationReference.value = {
        uuid: geolocation.uuid,
        manualMethod: 'address',
        address: geolocation.address || '',
        zipCode: geolocation.zipCode || '',
        city: geolocation.city || '',
        country_code: country_code,
        latitude: String(geolocation.latitude) || '',
        longitude: String(geolocation.longitude) || '',
        formattedAddress: geolocation.formattedAddress || ''
    };

    editDialogVisible.value = true;
};

const closeEditDialog = () => {
    editDialogVisible.value = false;
    selectedGeolocation.value = null;
    geolocationStore.setEditMode(false);
    resetForm();
};

const addGeolocation = async (payload: any) => {
    addLoading.value = true;
    try {
        const productUuid = getTechnicalUuid();
        if (!productUuid) {
            throw new Error('UUID du produit non trouvé');
        }

        await axios.post(`/admin/geolocation-products`, {
            ...payload,
            uuid: productUuid
        });

        await fetchProductData(productUuid);

        toast.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'La géolocalisation a été ajoutée avec succès',
            life: 3000,
        });

        closeAddDialog();
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.response?.data?.message || error.message || 'Une erreur est survenue lors de l\'ajout',
            life: 5000,
        });
    } finally {
        addLoading.value = false;
    }
};

const updateGeolocation = async (formData: any) => {
    if (!selectedGeolocation.value) return;

    loading.value = true;
    try {
        await fetchProductData(route.params.uuid as string);
        toast.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'La géolocalisation a été modifiée avec succès',
            life: 3000,
        });
        closeEditDialog();
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.message || 'Une erreur est survenue lors de la modification',
            life: 3000,
        });
    } finally {
        loading.value = false;
    }
};

const submitEditForm = async () => {
    editLoading.value = true;
    try {
        if (!selectedGeolocation.value || !geolocationStore.uuid) {
            throw new Error('Données de géolocalisation manquantes');
        }

        const payload = geolocationStore.createPayload();

        payload.country_code = getCountryCodeByName(payload.country_code);

        const geoUuid = geolocationStore.uuid;
        const url = `/admin/geolocation-products/${geoUuid}`;
        await axios.patch(url, payload);

        await fetchProductData(getTechnicalUuid());

        toast.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'La géolocalisation a été mise à jour avec succès',
            life: 3000,
        });

        closeEditDialog();
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.response?.data?.message || error.message || 'Une erreur est survenue lors de la mise à jour',
            life: 5000,
        });
    } finally {
        editLoading.value = false;
    }
};

const confirmDelete = async () => {
    if (!selectedGeolocationUuid.value) return;

    deleteLoading.value = true;
    try {
        await deleteGeolocation(selectedGeolocationUuid.value);

        const techUuid = localStorage.getItem('technicalVariantUuid');
        if (!techUuid) {
            throw new Error('UUID technique non trouvé');
        }

        await fetchProductData(techUuid);

        toast.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'La géolocalisation a été supprimée avec succès',
            life: 3000,
        });
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.message || 'Une erreur est survenue lors de la suppression',
            life: 3000,
        });
    } finally {
        deleteLoading.value = false;
        deleteDialogVisible.value = false;
        selectedGeolocationUuid.value = null;
    }
};

const searchGeolocationsByFilter = async (field: string, value: string) => {
    if (!value || value.trim() === '') {
        if (isApiFiltered.value) {
            return resetApiSearch();
        }
        return;
    }

    try {
        loading.value = true;
        isApiFiltered.value = true;
        currentPage.value = 1;

        const productUuid = getTechnicalUuid();

        const paginationParams = {
            page: String(currentPage.value),
            itemsPerPage: String(rowsPerPage.value)
        };

        let searchField = field;
        let searchValue = value.trim();

        let response;

        if (productService.searchGeolocations) {
            response = await productService.searchGeolocations(
                productUuid,
                searchField,
                searchValue,
                paginationParams
            );
        } else {
            const endpoint = `/admin/product/${productUuid}/geolocation`;
            const params: Record<string, string> = {
                ...paginationParams
            };
            params[searchField] = searchValue;

            const url = buildApiUrl(endpoint, params);
            const axiosResponse = await axios.get(url);
            response = axiosResponse.data;
        }

        let items = [];
        let total = 0;

        if (response) {
            if (response['hydra:member'] && Array.isArray(response['hydra:member'])) {
                items = response['hydra:member'];
                total = response['hydra:totalItems'] || 0;
            }
            else if (response.items && Array.isArray(response.items)) {
                items = response.items;
                total = response.totalItems || 0;
            }
            else if (response.data && response.data['hydra:member'] && Array.isArray(response.data['hydra:member'])) {
                items = response.data['hydra:member'];
                total = response.data['hydra:totalItems'] || 0;
            }
            else if (response.data && Array.isArray(response.data)) {
                items = response.data;

                if (response.totalItems !== undefined) {
                    total = response.totalItems;
                } else if (response.data['hydra:totalItems'] !== undefined) {
                    total = response.data['hydra:totalItems'];
                } else {
                    total = totalItems.value > 0 ? totalItems.value : items.length;
                }
            }
            else if (Array.isArray(response)) {
                items = response;
                total = totalItems.value > 0 ? totalItems.value : items.length;
            }
        }

        if (items.length > 0) {
            geolocations.value = items;
            totalItems.value = total;
            forceTableRefresh();

            toast.add({
                severity: 'info',
                summary: 'Recherche',
                detail: `${total} résultat(s) trouvé(s)`,
                life: 3000,
            });
        } else {
            geolocations.value = [];
            totalItems.value = 0;
            forceTableRefresh();

            toast.add({
                severity: 'info',
                summary: 'Recherche',
                detail: 'Aucun résultat trouvé',
                life: 3000,
            });
        }
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur de recherche',
            detail: error.response?.data?.message || error.message || 'Erreur lors de la recherche',
            life: 3000,
        });

        geolocations.value = [];
        totalItems.value = 0;
        forceTableRefresh();
    } finally {
        loading.value = false;
    }
};

const resetApiSearch = async () => {
    loading.value = true;

    try {
        searchId.value = '';
        searchLatitude.value = '';
        searchLongitude.value = '';
        searchAddress.value = '';
        searchCountry.value = '';

        geolocationFilters.value.formattedAddress.value = null;
        geolocationFilters.value.latitude.value = null;
        geolocationFilters.value.longitude.value = null;
        geolocationFilters.value.country_code.value = null;
        geolocationFilters.value.global.value = null;

        currentSearchField.value = '';
        currentSearchValue.value = '';
        isApiFiltered.value = false;

        currentPage.value = 1;

        const techUuid = getTechnicalUuid();
        await fetchProductData(techUuid, 1);

        forceTableRefresh();

        toast.add({
            severity: 'info',
            summary: 'Recherche réinitialisée',
            detail: 'Toutes les données ont été rechargées',
            life: 3000,
        });
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.message || 'Une erreur est survenue lors de la réinitialisation',
            life: 3000,
        });
    } finally {
        loading.value = false;
    }
};

watch([
    () => geolocationFilters.value.global.value,
    searchLatitude,
    searchLongitude,
    searchAddress,
    currentPage,
    rowsPerPage
], () => {
}, { deep: true });

const buildApiUrl = (endpoint: string, params?: Record<string, string>) => {
    let url = endpoint;
    if (params && Object.keys(params).length > 0) {
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                queryParams.append(key, value);
            }
        });

        const queryString = queryParams.toString();
        if (queryString) {
            url += (url.includes('?') ? '&' : '?') + queryString;
        }
    }

    return url;
};

const previousSearchLatitude = ref('');
const previousSearchLongitude = ref('');
const previousSearchAddress = ref('');
const previousSearchCountry = ref('');
const previousGlobalSearch = ref('');

const handleColumnSearch = (field: string, value: string) => {
    let previousValue = '';

    switch (field) {
        case 'latitude':
            previousValue = previousSearchLatitude.value;
            previousSearchLatitude.value = value;
            break;
        case 'longitude':
            previousValue = previousSearchLongitude.value;
            previousSearchLongitude.value = value;
            break;
        case 'formattedAddress':
            previousValue = previousSearchAddress.value;
            previousSearchAddress.value = value;
            break;
        case 'country_code':
            previousValue = previousSearchCountry.value;
            previousSearchCountry.value = value;
            break;
        case 'search':
            previousValue = previousGlobalSearch.value;
            previousGlobalSearch.value = value;
            break;
    }

    if (value !== previousValue) {
        if (value && value.trim() !== '' && value.trim().length >= 2) {
            debounceApiSearch(field, value, previousValue);
        } else if (isApiFiltered.value && previousValue && !value) {
            resetApiSearch();
        }
    }
};

const debounceApiSearch = debounce((field: string, value: string, previousValue: string) => {
    searchGeolocationsByFilter(field, value.trim());
}, 500);

const handleGlobalSearchImmediate = () => {
    const searchValue = geolocationFilters.value.global.value;

    if (searchValue && searchValue.trim() !== '') {
        searchGeolocationsByFilter('search', searchValue.trim());
    } else if (isApiFiltered.value) {
        resetApiSearch();
    }
};

const validateSearchResponse = (response: any) => {
    let total = 0;

    if (response) {
        if (response['hydra:totalItems'] !== undefined) {
            total = response['hydra:totalItems'];
        } else if (response.totalItems !== undefined) {
            total = response.totalItems;
        } else if (response.data && response.data['hydra:totalItems'] !== undefined) {
            total = response.data['hydra:totalItems'];
        }
    }
    return total;
};

const getTechnicalUuid = (): string => {
    const techUuid = route.params.uuid;
    if (!techUuid || typeof techUuid !== 'string') {
        throw new Error('UUID technique non trouvé dans l\'URL');
    }
    return techUuid;
};

const submitAddForm = async () => {
    const formData = geolocationStore.createPayload();

    const payload = {
        uuid: formData.uuid || undefined,
        address: formData.address || null,
        city: formData.city || null,
        zipCode: formData.zipCode || null,
        country_code: formData.country_code,
        formattedAddress: formData.formattedAddress || null,
        latitude: typeof formData.latitude === 'string' ? parseFloat(formData.latitude) : formData.latitude,
        longitude: typeof formData.longitude === 'string' ? parseFloat(formData.longitude) : formData.longitude
    };

    await addGeolocation(payload);
};

onMounted(() => {
    try {
        const techUuid = getTechnicalUuid();
        fetchProductData(techUuid);
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.message || 'UUID technique non trouvé',
            life: 3000,
        });
    }
});

function submitUploadFileAddresses(data) {
    openImportFileDialog.value = false;
    const form = new FormData();
    form.append('file', data.file[0].file);
    form.append('variantProduct', '/api/variant-product/' + getTechnicalUuid());
    form.append('countryCode', selectedImportCountry.value);
    swal.success("L'import des adresses est en cours","");
    return ApiService.post('product_geoloc_imports', form)
        .then(({data}) => {
             fetchProductData(getTechnicalUuid());
            toast.add({
                severity: 'success',
                summary: 'Succès',
                detail: "L'import des adresses est terminé avec succès. Vous recevrez un mail recap.",
                life: 3000,
            });
        })
        .catch(({response}) => {
            swal.error('Fichier au mauvais format');
        });
}

function downloadCsvTemplate() {
    const headers = ['Adresse', 'Code Postal', 'Ville'];
    const rows = [
        ['5 Rue Feydeau', '75002', 'Paris'],
        ['6 Rue Feydeau', '75002', 'Paris'],
        ['7 Rue Feydeau', '75002', 'Paris']
    ];
    let csvContent = headers.join(';') + '\n';
    rows.forEach(row => {
        csvContent += row.join(';') + '\n';
    });
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'adresses.csv');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dialog), {
      visible: openAddPositionDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((openAddPositionDialog).value = $event)),
      modal: "",
      header: "Ajouter une position",
      style: { width: '30rem' },
      onHide: resetForm
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            label: "Annuler",
            onClick: closeAddDialog,
            class: "button-cancel"
          }),
          _createVNode(_unref(Button), {
            label: "Ajouter",
            onClick: submitAddForm,
            class: "p-button-primary",
            loading: addLoading.value
          }, null, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(FormGeolocation, {
            index: 0,
            number: 1,
            reference: geolocationReference.value,
            optionsCountry: countryOptions.value,
            onSubmit: addGeolocation,
            onCancel: closeAddDialog
          }, null, 8, ["reference", "optionsCountry"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: editDialogVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((editDialogVisible).value = $event)),
      modal: "",
      header: "Modifier la position",
      style: { width: '30rem' },
      onHide: resetForm
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Button), {
            label: "Annuler",
            onClick: closeEditDialog,
            class: "button-cancel"
          }),
          _createVNode(_unref(Button), {
            label: "Editer",
            onClick: submitEditForm,
            class: "button-connfirm",
            loading: editLoading.value
          }, null, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(FormGeolocation, {
            index: 0,
            number: 1,
            reference: geolocationReference.value,
            optionsCountry: countryOptions.value,
            onSubmit: updateGeolocation,
            onCancel: closeEditDialog,
            isEditMode: true
          }, null, 8, ["reference", "optionsCountry"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: deleteDialogVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((deleteDialogVisible).value = $event)),
      modal: "",
      header: "Confirmation de suppression",
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Button), {
            label: "Non",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteDialogVisible.value = false)),
            class: "button-cancel"
          }),
          _createVNode(_unref(Button), {
            label: "Oui",
            onClick: confirmDelete,
            class: "button-connfirm",
            loading: deleteLoading.value
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: openImportFileDialog.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((openImportFileDialog).value = $event)),
      modal: "",
      header: "Importer un fichier CSV d'adresses",
      style: { width: '30rem' },
      onHide: resetForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "form",
          actions: false,
          "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement.",
          onSubmit: submitUploadFileAddresses
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _createVNode(_component_FormKit, {
                type: "file",
                label: "fichier csv*",
                help: "Sélectionnez le fichier à uploader.",
                accept: ".csv",
                placeholder: "Pas de fichier sélectionné.",
                validation: "required|validateFileExtension:csv",
                "validation-messages": {
              required: 'Aucun fichier sélectionné.',
              validateFileExtension: 'Le fichier doit être au format CSV.'
            },
                name: "file"
              }, null, 8, ["validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "select",
                label: "Pays*",
                name: "country_code",
                modelValue: selectedImportCountry.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedImportCountry).value = $event)),
                options: countryOptions.value,
                help: "Sélectionnez le pays pour les adresses importées."
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Button), {
                  label: "Annuler",
                  onClick: closeImportFileDialog,
                  class: "button-cancel"
                }),
                _createVNode(_unref(Button), {
                  label: "Importer",
                  type: "submit",
                  class: "p-button-primary",
                  loading: addLoading.value
                }, null, 8, ["loading"])
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: "#",
            onClick: downloadCsvTemplate,
            style: {"text-decoration":"underline"}
          }, "Modèle du fichier CSV")
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h1", _hoisted_7, [
        _createTextVNode("La liste des positions de "),
        _createElementVNode("b", null, _toDisplayString(productName.value), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Button), {
          label: "Ajouter une position",
          onClick: _cache[6] || (_cache[6] = () => { resetFormBeforeShow(); openAddPositionDialog.value = true; }),
          icon: "pi pi-plus",
          "aria-label": "Ouvrir le formulaire d'ajout de position",
          class: "button-add"
        }),
        _createVNode(_unref(Button), {
          label: "Importer un fichier CSV d'adresses",
          onClick: _cache[7] || (_cache[7] = () => { openImportFileDialog.value = true }),
          icon: "pi pi-plus",
          "aria-label": "Ouvrir le formulaire pour importer un fichier CSV",
          class: "button-add"
        })
      ])
    ]),
    _createElementVNode("p", _hoisted_9, [
      _createTextVNode(" Nombre total de géolocalisations : "),
      _createElementVNode("b", null, _toDisplayString(totalItems.value), 1)
    ]),
    (_openBlock(), _createBlock(_unref(DataTable), {
      key: tableKey.value,
      value: geolocations.value,
      paginator: "",
      rows: rowsPerPage.value,
      totalRecords: totalItems.value,
      loading: loading.value,
      lazy: true,
      onPage: onPageChange,
      dataKey: "id",
      globalFilterFields: ['id', 'formattedAddress', 'latitude', 'longitude'],
      stripedRows: "",
      tableStyle: "min-width: 50rem",
      resizableColumns: "",
      columnResizeMode: "fit",
      showGridlines: "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
      rowsPerPageOptions: [10, 20, 30, 50, 100],
      first: (currentPage.value - 1) * rowsPerPage.value,
      alwaysShowPaginator: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _hoisted_12,
            _createVNode(_unref(InputText), {
              class: "p-4 w-[300px]",
              modelValue: geolocationFilters.value.global.value,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((geolocationFilters.value.global.value) = $event)),
                _cache[9] || (_cache[9] = (val) => handleColumnSearch('search', val))
              ],
              onKeyup: _withKeys(handleGlobalSearchImmediate, ["enter"]),
              placeholder: "Rechercher dans tout le tableau"
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (isApiFiltered.value)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  label: "Réinitialiser la recherche",
                  icon: "pi pi-refresh",
                  onClick: resetApiSearch,
                  class: "p-button-outlined p-button-sm"
                }))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createVNode(_unref(ProgressSpinner), { style: {"width":"20px","height":"20px"} }),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createVNode(_unref(Button), {
            label: "Ajouter une position",
            onClick: _cache[10] || (_cache[10] = () => { resetFormBeforeShow(); openAddPositionDialog.value = true; }),
            class: "mt-2 button-add"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          header: "#",
          class: "max-w-[30px]"
        }, {
          body: _withCtx(({ index }) => [
            _createTextVNode(_toDisplayString((currentPage.value - 1) * rowsPerPage.value + index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "id",
          header: "Id",
          class: "max-w-[70px]"
        }),
        _createVNode(_unref(Column), {
          field: "latitude",
          header: "Latitude",
          class: "max-w-[100px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(InputText), {
                  class: "w-full p-2 min-w-[100px]",
                  modelValue: searchLatitude.value,
                  "onUpdate:modelValue": [
                    _cache[11] || (_cache[11] = ($event: any) => ((searchLatitude).value = $event)),
                    _cache[12] || (_cache[12] = (val) => handleColumnSearch('latitude', val))
                  ],
                  onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (searchGeolocationsByFilter('latitude', searchLatitude.value)), ["enter"])),
                  placeholder: "Latitude"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "longitude",
          header: "Longitude",
          class: "max-w-[100px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(InputText), {
                  class: "w-full p-2 min-w-[100px]",
                  modelValue: searchLongitude.value,
                  "onUpdate:modelValue": [
                    _cache[14] || (_cache[14] = ($event: any) => ((searchLongitude).value = $event)),
                    _cache[15] || (_cache[15] = (val) => handleColumnSearch('longitude', val))
                  ],
                  onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (searchGeolocationsByFilter('longitude', searchLongitude.value)), ["enter"])),
                  placeholder: "Longitude"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "formattedAddress",
          header: "Adresse",
          class: "min-w-[100px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(InputText), {
                  class: "w-full p-2",
                  modelValue: searchAddress.value,
                  "onUpdate:modelValue": [
                    _cache[17] || (_cache[17] = ($event: any) => ((searchAddress).value = $event)),
                    _cache[18] || (_cache[18] = (val) => handleColumnSearch('formattedAddress', val))
                  ],
                  onKeyup: _cache[19] || (_cache[19] = _withKeys(($event: any) => (searchGeolocationsByFilter('formattedAddress', searchAddress.value)), ["enter"])),
                  placeholder: "Adresse"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_25, _toDisplayString((data.longitude && data.longitude)  ? data.formattedAddress : 'Adresse vide ou géolocalisation désactivée'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "country_code",
          header: "Pays",
          class: "max-w-[100px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_unref(InputText), {
                  class: "w-full p-2",
                  modelValue: searchCountry.value,
                  "onUpdate:modelValue": [
                    _cache[20] || (_cache[20] = ($event: any) => ((searchCountry).value = $event)),
                    _cache[21] || (_cache[21] = (val) => handleColumnSearch('country_code', val))
                  ],
                  onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => (searchGeolocationsByFilter('country_code', searchCountry.value)), ["enter"])),
                  placeholder: "Pays"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data.country_code ? countryOptions.value[data.country_code] || data.country_code : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Actions",
          class: "whitespace-nowrap max-w-[80px]"
        }, {
          body: _withCtx(({ data }) => [
            (data.longitude && data.longitude)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-pencil",
                    class: "p-edition",
                    style: {"margin-right":"0.5em"},
                    title: "Modifier",
                    onClick: ($event: any) => (openEditDialog(data))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    style: {"margin-right":"0.5em"},
                    title: "Supprimer",
                    onClick: ($event: any) => (openDeleteDialog(data.uuid)),
                    loading: deleteLoading.value && selectedGeolocationUuid.value === data.uuid
                  }, null, 8, ["onClick", "loading"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "rows", "totalRecords", "loading", "first"]))
  ]))
}
}

})